import { render, staticRenderFns } from "./CreateRoom.vue?vue&type=template&id=0d70f56c"
import script from "./CreateRoom.vue?vue&type=script&lang=js"
export * from "./CreateRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports